module.exports = __webpack_public_path__ + "img/display.d30fce29.svg";